// extracted by mini-css-extract-plugin
export default {"price":"R--z","onSale":"S--z","msrpLabelPrice":"T--z","msrpLabel":"U--z","originalPrice":"V--z","percentOff":"W--z"};